// extracted by mini-css-extract-plugin
module.exports = {"description":"_35MKEvJAv0wjnRr6XIdoIf","pageHeader":"_3lQwjNUatnb6b91BLfQ1XL","icon":"_9XxmtGzxnnB4cbSc85eQ-","table":"_3QFTl4rl9-97nHzHJB5AdH"};